import Tooltip, {TooltipProps} from "@material-ui/core/Tooltip";
import React, { ReactElement, ReactNode } from 'react';

interface DefaultTooltipProps {
  title?: ReactNode;
  placement?: TooltipProps['placement'];
  classes?: TooltipProps['classes'];
  children: ReactElement;
  open?: boolean;
  arrow?: boolean;
}

const DefaultTooltip: React.FC<DefaultTooltipProps> = ({
  title,
  placement = 'right',
  classes,
  children,
  open,
  arrow = false,
}) => {
  return !!title ? (
    <Tooltip
      arrow={arrow}
      open={open}
      placement={placement}
      title={title}
      classes={classes}
      //PopperProps={{disablePortal: true}}
    >
      {children}
    </Tooltip>
  ) : (
    children
  );
};

export default DefaultTooltip;
